//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";
import { APP_DATE_HOUR_MIN_FORMAT, APP_DATE_DOT_DMY_FORMAT } from "@/assets/js/appConfig";
import {
    setPluginIconColor,
    formatTimeToSend,
    eventBus,
    convertAndFormatTimeToLocal
} from "@/assets/js/appFunc";
import PIMessageModal from "@/components/Admin/ProcessInspector/PIMessageModal.vue";
import FabricSearch from "@/components/q-fabric-search.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import tabComponents from "../mixins/tab-components";
import TabContent from "./TabContent.vue";

export default {
    components: {
        TabContent,
        FabricSearch,
        PIMessageModal,
        AQCard,
        AQInput,
        AQButton,
        AQTooltip
    },
    mixins: [tabComponents],
    props: {
        instanceID: {
            type: String,
            default: ""
        },
        instanceName: {
            type: String,
            default: ""
        },
        systemStatus: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            showProcessInformationMessagesModal: false,
            searchMessage: "",
            fromDateMessages: "",
            toDateMessages: "",
            noFromDateMsgFound: false,
            noToDateMsgFound: false,
            showClearIconFrom: true,
            showClearIconTo: true,
            mode: "msg",
            message: null,
            showLoadMoreMsgBtn: false,
            messagesListExists: true,
            messagesList: [],
            msgPayload: {
                dateFrom: "",
                dateTo: "",
                generalSearch: "",
                page: 0,
                processInstanceId: this.instanceID,
                size: 5,
                sortDirection: "DESC",
                sortField: "creationDate"
            }
        };
    },
    computed: {
        messagesModalProps() {
            return {
                message: this.message,
                instanceStatus: this.systemStatus,
                instanceName: this.instanceName,
                id: this.message.notificationAuditId,
                processInspectorMessagesModal: this.showProcessInformationMessagesModal
            };
        }
    },
    watch: {
        fromDateMessages: {
            handler(newValue) {
                this.updateDate(newValue);
                this.showClearIconFunc(newValue, "fromStartDateMsg");
            }
        },
        toDateMessages: {
            handler(newValue) {
                this.updateDate(newValue);
                this.showClearIconFunc(newValue, "toStartDateMsg");
            }
        }
    },
    beforeDestroy() {
        eventBus.$off("messagesRefreshTab");
    },
    mounted() {
        this.msgsDetailsCall();
        eventBus.$on("messagesRefreshTab", () => {
            this.msgsDetailsCall();
        });
    },
    methods: {
        setPluginIconColor,
        formatTimeToSend,
        convertAndFormatTimeToLocal,
        ...mapActions("admin", ["getMessagesDetails"]),

        openMsgModal(message) {
            if (!message.deleteEventList) {
                this.showProcessInformationMessagesModal = true;
                this.message = message;
            }
        },
        tooltipContent(message) {
            return this.$t("admin.processInspector.deletedTooltip",
                { user: message.username, time: this.convertAndFormatTimeToLocal(message.execDate, APP_DATE_DOT_DMY_FORMAT) });
        },
        showClearIconFunc(value, state) {
            if (state === "fromStartDateMsg") {
                this.showClearIconFrom = !!value;
            } else if (state === "toStartDateMsg") {
                this.showClearIconTo = !!value;
            }
        },

        loadMoreItems() {
            ++this.msgPayload.page;
            this.msgsDetailsCall(true);
        },
        msgsDetailsCall(loadMore) {
            if (!loadMore) {
                this.msgPayload.page = 0;
            }
            this.getMessagesDetails(this.msgPayload).then(data => {
                this.messagesList = loadMore ? this.messagesList.concat(data.data.list) : data.data.list;
                this.showLoadMoreMsgBtn = this.msgPayload.size * (this.msgPayload.page + 1) < data.data.totalElements;
                this.messagesListExists = data.data.list && data.data.list.length;
            });
        },
        messageDelete(data) {
            for (let i = 0; i < this.messagesList.length; i++) {
                if (this.messagesList[i].notificationAuditId === data.notificationAuditId) {
                    this.messagesList[i] = data;
                }
            }
        },

        updateDate(value) {
            const fromDate = this.fromDateMessages;
            const toDate = this.toDateMessages;
            const payload = this.msgPayload;
            if (value) {
                if (fromDate && toDate) {
                    this.noFromDateMsgFound = false;
                    this.noToDateMsgFound = false;
                    payload.dateFrom = this.formatTimeToSend(
                        fromDate,
                        APP_DATE_HOUR_MIN_FORMAT
                    );
                    payload.dateTo = this.formatTimeToSend(
                        toDate,
                        APP_DATE_HOUR_MIN_FORMAT
                    );
                    payload.size = 5;
                    this.msgsDetailsCall();
                } else if (!fromDate && toDate) {
                    this.noFromDateMsgFound = true;
                } else if (fromDate && !toDate) {
                    this.noToDateMsgFound = true;
                }
            }
        },
        updateModel(isFrom) {
            const fromDate = this.fromDateMessages;
            const toDate = this.toDateMessages;
            if (isFrom) {
                this.fromDateBlockchain = "";
                if (toDate) {
                    this.noFromDateMsgFound = true;
                    this.noToDateMsgFound = false;
                } else {
                    this.noToDateMsgFound = false;
                    this.setPayloadOnUpdateModel();
                }
            } else {
                this.toDateMessages = "";
                if (fromDate) {
                    this.noFromDateMsgFound = false;
                    this.noToDateMsgFound = true;
                } else {
                    this.noFromDateMsgFound = false;
                    this.setPayloadOnUpdateModel();
                }
            }
        },
        setPayloadOnUpdateModel() {
            this.noFromDateMsgFound = false;
            this.msgPayload.dateFrom = "";
            this.msgPayload.dateTo = "";
            this.msgPayload.size = 5;
            this.blockchainDetailsCall();
        },
        searchTermDataMessage(value) {
            this.msgPayload.generalSearch = value;
            this.msgPayload.size = 5;
            this.msgsDetailsCall();
        }
    }
};
